import { useContext, useMemo } from "react";
import { ProductContext } from "../../../context/product-context/productContext";
import { Product } from "../../../context/product-context/product.ts";

const doesProdcutHaveInsurancePlus = (product: Product) =>
  product?.hasFeature("INSURANCE_PLUS_INCLUDED") ||
  product?.hasFeature("INSURANCE_PLUS_INCLUDED_SWISSCARD");

/**
 * Insurance Plus product feature support.
 */
const useInsurancePlus = () => {
  const { selectedProduct } = useContext(ProductContext);

  const hasInsurancePlus = useMemo(
    () => doesProdcutHaveInsurancePlus(selectedProduct),
    [selectedProduct],
  );

  return useMemo(
    () => ({
      hasInsurancePlus,
      doesProdcutHaveInsurancePlus,
    }),
    [hasInsurancePlus],
  );
};

export default useInsurancePlus;
